import { FormattedMessage } from 'react-intl';

type Props = {
  readonly max: number;
};

const MaxCharacters = ({ max }: Props): JSX.Element => {
  return (
    <FormattedMessage
      id="account_v2.components.form_errors.max_characters"
      defaultMessage="Use a maximum of {max} characters."
      values={{
        max: max.toString(),
      }}
    />
  );
};

export default MaxCharacters;
